module.exports = __webpack_public_path__ + "img/user.png?3d4f56792b36520544486a3f677a6d89";